import React from "react";
import {
	Drawer,
	DrawerOverlay,
	DrawerContent,
	DrawerHeader,
	DrawerBody,
	DrawerCloseButton,
} from "@chakra-ui/react";
import {
	ViewProjectDetail,
	type ViewProjectDetailData,
} from "./ViewProjectDetail";

interface ViewProjectDetailDrawerProps {
	isOpen: boolean;
	profileTypeId?: number;
	project: ViewProjectDetailData | null;
	onClose: () => void;
}

export const ViewProjectDetailDrawer: React.FC<ViewProjectDetailDrawerProps> = ({
	isOpen,
	onClose,
	project,
	profileTypeId,
}) => {
	if (!project) return null;

	return (
		<Drawer isOpen={isOpen} onClose={onClose} size="lg" placement="right" blockScrollOnMount={false}>
			<DrawerOverlay />
			<DrawerContent
				display="flex"
				flexDirection="column"
				onWheel={(e) => e.stopPropagation()}
			>
				<DrawerHeader borderBottomWidth="1px" flexShrink={0} pr={12}>
					{project.name}
					<DrawerCloseButton />
				</DrawerHeader>
				<DrawerBody flex={1} overflowY="auto">
					<ViewProjectDetail
						project={project}
						profileTypeId={profileTypeId}
					/>
				</DrawerBody>
			</DrawerContent>
		</Drawer>
	);
};
